/**
 * 图标配置
 */

import { createFromIconfontCN } from '@ant-design/icons';
import * as iconUrl from '../../public/iconfont';
// import iconUrl from '../assets/iconfont';
const IconFont = createFromIconfontCN({
  // scriptUrl: '//at.alicdn.com/t/font_2111099_l8wf0bq5dji.js',
  scriptUrl: iconUrl,
});

export default IconFont;
